import { FC, HTMLAttributes } from "react";
import { HelpHint } from "src/Components";
import clx from "classnames";
import st from "./FieldGroup.module.scss";

interface IInputProps extends HTMLAttributes<HTMLDivElement> {
	name: string;
	title: string;
	readOnly?: boolean;
	isRequired?: boolean;
	isInvalid?: boolean;
	errorMsg?: string;
	width: number;
	tooltip?: string;
	isCaptionOnly?: boolean;
	hasClearIcon?: boolean;
};

const FieldGroup: FC<IInputProps> = ( props ) => {

	const { name, title, readOnly = false, isCaptionOnly = false, isRequired = false, isInvalid = false, tooltip = '',
		hasClearIcon = false,
		children, width, errorMsg, className, ...otherProps 
	} = props;

	const getFieldClass = ( width: number ): string => {
		if ( !width ) return 'flex';
		else if ( width === 1 ) {
			return 'flex1';
		} 
		else if ( width === 3 ) {
			return 'flex3';
		} 
		else if ( width === 4 ) {
			return 'flex4';
		} 
		else if ( width === 6 ) {
			return 'flex6';
		}
		return '';
	};

	const classes = clx(st.fieldGroup, className, st[getFieldClass(width)], {
		[st.required]: isRequired && !isCaptionOnly,
		[st.readOnly]: readOnly && !isCaptionOnly,
		[st.error]: isInvalid,
		[st.captionOnly]: isCaptionOnly,
		[st.withClearIcon]: hasClearIcon
	});

	if ( isInvalid ) {
		console.info( `Ошибка валидации поля ${title} ( ${name} ). Текст ошибки - ${errorMsg} .` );
	}

	return (
		<div className={classes} {...otherProps}>
			{
				( !!title || !!tooltip ) &&
				<div className={st.fieldGroupHeader}>
					{ title && <label htmlFor={ !isCaptionOnly ? name : ''}>{title}</label> }
					{ !!tooltip && <HelpHint title={ tooltip } /> }
				</div>
			}
			{ children }
		</div>
	);
};

export default FieldGroup;
